// Central API base URL for all requests
// During development with setupProxy.js, use relative URLs
// In production, use the full Azure API URL
const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL = isDevelopment && isLocalhost 
  ? '' // Use relative URLs for setupProxy.js to intercept
  : (process.env.REACT_APP_API_URL || "https://webapp-python-nlng-bots-api-cuasbrg3h5cyewgm.westeurope-01.azurewebsites.net");

/**
 * Send message reaction (like/dislike) to the backend
 * @param {string} messageId - The ID of the message being reacted to
 * @param {string} conversationId - The ID of the conversation
 * @param {string} userId - The ID of the user
 * @param {'like' | 'dislike'} reaction - The reaction type
 * @param {string} paramsTag - The params tag (e.g., 'HSE_PARAMS', 'QMS_PARAMS', 'POS_PARAMS')
 * @returns {Promise<Object>} Response from the API
 */
export const sendChatReaction = async (messageId, conversationId, userId, reaction, paramsTag = 'QMS_PARAMS') => {
  const reactionPayload = {
    like: reaction === 'like' ? 1 : 0,
    dislike: reaction === 'dislike' ? 1 : 0,
  };

  const requestBody = {
    message_id: String(messageId),
    params_tag: paramsTag,
    reaction: reactionPayload,
    conversation_id: conversationId,
    user_id: userId,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/v1/api/c/chat-reaction`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    console.log('Reaction sent successfully:', data);
    return data;
  } catch (error) {
    console.error('Error sending reaction:', error);
    throw error;
  }
};

/**
 * Fetch the saved reaction state for a specific message
 * @param {string} messageId - The ID of the message
 * @param {string} conversationId - The ID of the conversation
 * @param {string} userId - The ID of the user
 * @param {string} paramsTag - The params tag (e.g., 'HSE_PARAMS', 'QMS_PARAMS')
 * @returns {Promise<{ like: number, dislike: number } | null>}
 */
export const getReactionData = async (messageId, conversationId, userId, paramsTag = 'QMS_PARAMS') => {
  try {
    const query = new URLSearchParams({
      message_id: String(messageId),
      params_tag: paramsTag,
      conversation_id: String(conversationId),
      user_id: String(userId),
    }).toString();
    const response = await fetch(`${API_BASE_URL}/v1/api/c/get-reaction-data?${query}`);
    if (!response.ok) return null;
    const data = await response.json();
    return data?.reaction_metadata?.reaction ?? null;
  } catch (error) {
    console.error('Error fetching reaction data:', error);
    return null;
  }
};
